import React, { CSSProperties, useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
//import { Scrollbars } from 'react-custom-scrollbars-2';
import ConsumptionOverview from './consumptionOverview';

// Datepicker
import DatePicker from "react-datepicker";

import { Template } from 'devextreme-react/core/template';
import TreeList, { Column, Scrolling } from 'devextreme-react/tree-list';

//import transactionProsumerChartData from '../../data/prosumer/transactionProsumerChartData.json'
import transactionProsumerData from '../../data/prosumer/transactionProsumerData.json'
import moment from 'moment';

import PeriodCell from '../../components/periodCell'
import EnergySourceCell from '../../components/energySourceCellProsumer'
import BillPerPeriodCell from '../../components/billPerPeriodCell'
import UsagePerPeriodCell from '../../components/usagePerPeriodCell'

import DotLoader from "react-spinners/DotLoader";
import { getTransactions, getTransactionsData } from '../../services/admin.service';
import { CSVLink } from "react-csv";

// Datepicker

const override: CSSProperties = {
    display: "block",
    margin: "auto",
    marginTop: "250px",
    marginBottom: "200px",
    borderColor: "red",
};


interface TransactionChartDataObject {
    bill: {
        excess: number;
        retailer: number;
        t1: number;
        t2: number;
        total: number;
    };
    usage: {
        total: number;
        t1: number;
        t2: number;
        retailer: number;
        excess: number;
    }
    transactions: TransactionData[];
}

interface TransactionData {
    billPerPeriod: number;
    endDate: string;
    numberOfProviders: number;
    startDate: string;
    itemData: TransactionItem[];
    usagePerPeriod: number;
}

interface TransactionItem {
    name: string;
    usage: number;
    bill: number;
}

const Transactions = (props: any) => {
    const [chartData, setChartData] = useState<TransactionChartDataObject>();
    const [startDateT, setStartDateT] = useState<Date>(() => {
        const date = new Date();
        date.setDate(date.getDate() - 1);
        return date;
    });
    const [transactionData, setTransactionData] = useState<TransactionData[]>([]);
    const [csvData, setCsvData] = useState([["startDate", "endDate", "Customer", "Earnings (฿)", "KWh"]]);
    const [loading, setLoading] = useState(false);
    const color = "#006837";
    //const auth = JSON.parse(localStorage.getItem('auth')!);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setCsvData([["startDate", "endDate", "Customer", "Earnings (฿)", "KWh"]]);
            //const transactions = await getTransactionsData(moment(new Date(startDateT)).format('YYYY-MM-DD'), 1);

            const transactions = await getTransactions(moment(new Date(startDateT)).format('YYYY-MM-DD'), props.userIds, props.userType);

            setTransactionData(transactions.data.data.transactions);
            setChartData(transactions.data.data);
            // const csv: any = [];
            // transactions.data.data.transactions.forEach((item: any) => {
            //     csv.push([item.startDate, item.endDate, `Multiple (${item.numberOfProviders})`, item.billPerPeriod.toString(), item.usagePerPeriod.toString()])
            //     item.traded.forEach((tradedItem: any) => {
            //         csv.push(["", "", tradedItem.name, tradedItem.cost.toString(), tradedItem.allocation.toString()])
            //     })
            // });
            // setCsvData([...csvData, ...csv]);
            const csv: any = []
            transactions.data.data.transactions.forEach((item: any, key: number) => {
                if (key === 0) {
                    csv.push([["startDate"], ["endDate"], ["Customer"], [`Earnings (฿)`], ["KWh"]])
                }
                csv.push([item.startDate, item.endDate, (item.numberOfProviders > 0) ? `Multiple (${item.numberOfProviders})` : 'No Match', item.billPerPeriod.toString(), item.usagePerPeriod.toString()])
                item.itemData.forEach((tradedItem: any) => {
                    if (tradedItem.bill === -1) {
                        csv.push(["", "", tradedItem.name, "", tradedItem.usage]);
                    } else {
                        csv.push(["", "", tradedItem.name, tradedItem.bill, tradedItem.usage]);
                    }
                })
            })
            setCsvData(csv);
            setLoading(false);
        }
        fetchData();
        //const data = filterDate(new Date(startDateT).toString());
        //setTransactionData(data);
    }, [startDateT, props.userIds]);

    // const filterDate = (date: string) => {
    //     let data: any = transactionProsumerData
    //         .filter(item => (moment(new Date(item.startDate)).format('YYYY-MM-DD') === moment(new Date(date)).format('YYYY-MM-DD')));
    //     return data
    // }

    return (
        <div className='dashboardWidget'>
            <div className='widgetTitle'>
                <Row>
                    <Col>
                        <h3>Daily Energy Trading</h3>
                        <div>
                            <label className='reactdatepicker-label' htmlFor="reactDatePickerT">
                                <DatePicker
                                    dateFormat="eeee, dd MMM ′yy"
                                    selected={startDateT}
                                    className="datepicker"
                                    id='reactDatePickerT'
                                    onChange={date => date && setStartDateT(date)}
                                />
                            </label>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className='widgetBody py-4'>
                {loading ? <DotLoader
                    color={color}
                    loading={loading}
                    cssOverride={override}
                    size={50}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                /> :
                    <Row>
                        <Col sm="12" lg="9" md="8">
                            <TreeList
                                height={400}
                                width="100%"
                                dataSource={transactionData}
                                showBorders={true}
                                columnAutoWidth={true}
                                wordWrapEnabled={true}
                                onRowClick={function (e) {
                                    if (e.isExpanded)
                                        e.component.collapseRow(e.key);
                                    else
                                        e.component.expandRow(e.key);
                                }}
                                keyExpr="Transaction_ID"
                                parentIdExpr="Transaction_parent_ID"
                                id="transactions"
                                itemsExpr="itemData"
                                dataStructure="tree"
                            >
                                <Scrolling columnRenderingMode="standard" />
                                <Column
                                    dataField="startDate"
                                    caption="Period"
                                    width={300}
                                    cellTemplate={'PeriodCell'}
                                />
                                <Column
                                    dataField="name"
                                    caption="Customer"
                                    allowSorting={true}
                                    cellTemplate="energySourceTemplate"
                                >
                                </Column>
                                <Column
                                    dataField="billPerPeriod"
                                    caption="Credit / Debit (฿)"
                                    minWidth={100}
                                    cellTemplate="BillPerPeriodCell"
                                >
                                </Column>
                                <Column
                                    dataField="usagePerPeriod"
                                    caption="KWh"
                                    cellTemplate={"UsagePerPeriodCell"}
                                >
                                </Column>
                                <Template name="PeriodCell" render={PeriodCell} />
                                <Template name="energySourceTemplate" render={EnergySourceCell} />
                                <Template name="BillPerPeriodCell" render={BillPerPeriodCell} />
                                <Template name="UsagePerPeriodCell" render={UsagePerPeriodCell} />
                            </TreeList>

                            {/* <Scrollbars style={{ height: 400 }} 
                                    renderTrackHorizontal={props => <div {...props} style={{display: 'none'}} className="track-horizontal"/>}
                                    renderTrackVertical={props => <div {...props} className="track-virticle"/>}
                                    renderView={props => <div {...props} className="view"/>}
                                >
                                </Scrollbars> */}
                            <div className='text-end'>
                                <CSVLink data={csvData} filename={`24/7 CFE Daily Tracking - ${moment(new Date(startDateT)).format('YYYY-MM-DD').toUpperCase()}`} className='w700'><i className="fa-solid fa-download"></i> Download as CSV</CSVLink>
                            </div>
                        </Col>
                        <Col sm="12" lg="3" md="4">
                            <div>
                                <div className='totalConsumption text-end'>
                                    <h2 className='h1 mb-0'>{Number(Number(chartData?.bill.t1) + Number(chartData?.bill.t2)).toFixed(2)} ฿</h2>
                                    {/* <small>Total earning to date in {moment(new Date(startDateT)).format('MMMM').toUpperCase()}</small> */}
                                    <small>Total earning</small>
                                </div>
                                <hr />

                                <ul className='consumptionLedgend'>
                                    <li><i style={{ backgroundColor: '#006837' }}></i><span>24/7 CFE</span>
                                        <span className='count'>{(Number(chartData?.bill.t1) + Number(chartData?.bill.t2)).toFixed(2)} ฿<br /><small>({(Number(chartData?.usage.t1) + Number(chartData?.usage.t2)).toFixed(2)} kWh)</small>
                                        </span>
                                    </li>
                                    <li><i style={{ backgroundColor: '#e16838' }}></i><span>Unsold attributes</span>
                                        <span className='count'>{(Number(chartData?.bill.retailer) + Number(chartData?.bill.excess)).toFixed(2)} ฿<br /><small>({(Number(chartData?.usage.retailer) + Number(chartData?.usage.excess)).toFixed(2)} kWh)</small></span></li>
                                </ul>
                            </div>
                            <div>
                                <ConsumptionOverview
                                    unsold={(Number(chartData?.usage.retailer) + Number(chartData?.usage.excess)).toFixed(2)}
                                    greenEnergy={(Number(chartData?.usage.t1) + Number(chartData?.usage.t2)).toFixed(2)} />
                            </div>
                        </Col>
                    </Row>}
            </div>
        </div>
    )
}
export default Transactions;